'use client';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { HardDriveUpload, BotMessageSquare, FileText, ArrowRight } from 'lucide-react';

const steps = [
  {
    icon: <HardDriveUpload className="h-10 w-10 text-primary" />,
    title: '1. Enter Your URL',
    description: 'Simply provide the website URL you want us to analyze.',
  },
  {
    icon: <BotMessageSquare className="h-10 w-10 text-primary" />,
    title: '2. AI-Powered Analysis',
    description: 'Our intelligent system crawls and audits your site, checking key metrics.',
  },
  {
    icon: <FileText className="h-10 w-10 text-primary" />,
    title: '3. Get Your Detailed Report',
    description: 'Receive a comprehensive report with findings and actionable recommendations.',
  },
];

export function HowItWorksSection() {
  return (
    <section className="py-12 sm:py-16 bg-muted/50 w-full">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl font-headline">
            Simple Steps to a Better Website
          </h2>
          <p className="mt-4 text-lg leading-8 text-muted-foreground">
            Understand your website&apos;s health in just a few clicks.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-stretch">
          {steps.map((step, index) => (
            <div key={step.title} className="flex flex-col items-center">
              <Card className="w-full text-center shadow-lg hover:shadow-xl transition-shadow duration-300 flex-grow flex flex-col">
                <CardHeader>
                  <div className="mx-auto bg-primary/10 p-3 rounded-full mb-4 w-fit">
                    {step.icon}
                  </div>
                  <CardTitle className="text-xl font-headline">{step.title}</CardTitle>
                </CardHeader>
                <CardContent className="flex-grow">
                  <p className="text-muted-foreground">{step.description}</p>
                </CardContent>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
